import mailSmsApi from '@/api/mailsms'

const state = {
  unifiedData: {
    items: [],
    summary: {},
    pagination: {}
  },
  loading: false,
  error: null,
  lastFilters: null
}

const getters = {
  summaryCards: state => {
    const summary = state.unifiedData.summary
    return [
      { key: 'pending', label: '送信予定', count: summary.pending || 0 },
      { key: 'sent', label: '送信済み', count: summary.sent || 0 },
      { key: 'error', label: 'エラー', count: summary.error || 0 },
      { key: 'total', label: '全て', count: summary.total || 0 }
    ]
  }
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_UNIFIED_DATA(state, data) {
    state.unifiedData = data
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_LAST_FILTERS(state, filters) {
    state.lastFilters = filters
  }
}

const actions = {
  async fetchUnifiedData({ commit }, filters) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    commit('SET_LAST_FILTERS', filters)
    try {
      const response = await mailSmsApi.getUnifiedList(filters)
      commit('SET_UNIFIED_DATA', response.data)
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async stopMail({ dispatch, state }, unifiedId) {
    await mailSmsApi.stopMail(unifiedId)
    // 現在のフィルターで再取得
    if (state.lastFilters) {
      await dispatch('fetchUnifiedData', state.lastFilters)
    }
  },
  
  async resendMail({ dispatch, state }, unifiedId) {
    await mailSmsApi.resendMail(unifiedId)
    if (state.lastFilters) {
      await dispatch('fetchUnifiedData', state.lastFilters)
    }
  },
  
  async exportData({ state }, filters) {
    const response = await mailSmsApi.exportData(filters)
    // ダウンロード処理
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', 'mail_sms_export.csv')
    document.body.appendChild(link)
    link.click()
    link.remove()
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/mailsms.js